/**
 * Chart.js Plugin
 * Registers Chart.js components globally on app initialization
 * This prevents race conditions with chunk loading during build
 */
import {
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  Filler,
  Legend,
  LinearScale,
  LineElement,
  PointElement,
  Title,
  Tooltip
} from "chart.js";

export default defineNuxtPlugin(() => {
  // Register Chart.js components once on app initialization
  ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    BarElement,
    Title,
    Tooltip,
    Legend,
    Filler
  );
});
